export class TrimmingSetting
{
  enabled:boolean = true;
  fadeDuration:number = 0;
}

export class TrimmingOptions
{
  trimStart:TrimmingSetting = new TrimmingSetting();
  trimEnd:TrimmingSetting   = new TrimmingSetting();  
  tresholdDecibels:number   = -40;

  durationTrimming:boolean = false;
  maxDuration:number = 5;
  durationTrimmingFadeDuration:number = 0.1;  
}